import { render, staticRenderFns } from "./MerseysidePolice.vue?vue&type=template&id=8db999ec&scoped=true"
import script from "./MerseysidePolice.vue?vue&type=script&lang=js"
export * from "./MerseysidePolice.vue?vue&type=script&lang=js"
import style0 from "./MerseysidePolice.vue?vue&type=style&index=0&id=8db999ec&prod&scoped=true&lang=css"
import style1 from "./MerseysidePolice.vue?vue&type=style&index=1&id=8db999ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db999ec",
  null
  
)

export default component.exports